<template>
<div class="newsletter">
    <!-- <p class="label minor">Mailing list (<span style="text-decoration: line-through;">spam</span>)</p> -->
    <p class="label minor">Mailing list</p>
    <form 
        class="email-wrap" 
        @submit="subscribeNewsletter"
    >
        <input 
            placeholder="Email address"
            type="text"
            v-model="newsletterInput"
        />
        <button 
            class="subscribe"
            type="submit"
            value="Submit">
            <h1>Subscribe</h1>
        </button>
    </form>
</div>
</template>

<script>
import { db } from '../db'
export default {
  name: 'Newsletter',
  data() {
      return {
          newsletterInput: null,
      }
  },
  methods: {
      subscribeNewsletter() {
          if (this.newsletterInput) {
            console.log(this.newsletterInput)
            this.newsletterInput =  null
          }
      }
  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.newsletter {
    // background-color: $black;
    border-bottom: $line-bold solid $line-color-dark;
    margin: 0 $grid-padding;
    .label {
        margin: 0;
    }
    .email-wrap {
        display: flex;
        justify-content: space-between;
        line-height: 0px;
        margin-bottom: 10px;
        input {
            width: 100%;
            font-size: $h1;
            font-weight: $bold;
            border: 0;
        }
        button {
            background-color: transparent;
            text-decoration: none;
            border: none;
            padding: 0;
            margin: 0;
            &:hover {
                color: $icon-hover-color;
                cursor: pointer;
            }
            h1 {
                font-family: $family;
                font-size: $h1;
                font-weight: $bold;
                padding: 0;
                margin: 0;
            }
        }
    }
}

// MOBILE
@media #{$mobile} {    
    .newsletter {
        margin: 0 $main-margin-mobile;
        .email-wrap {
            display: flex;
            align-items: center;
            margin-bottom: 0;
            input {
                font-size: $h1-mobile;
            }
            button h1 {
                font-size: $h1-mobile;
            }
        }
    }
        
}

</style>
